import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/contractualizations/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllAdjustTypes: config.endpoints.backend + 'adjusttypes/getall',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointDelete: `${config.endpoints.backend}contractualizations/delete`,
        endpointGetAllProjectUnits: config.endpoints.backend + 'projectunits/getall',
        endpoint: config.endpoints.backend + 'contractualizations/getall'
    }
    const pathsForm = {
        endpointSave: config.endpoints.backend + 'contractualizations/save',
        endpointGetById: config.endpoints.backend + 'contractualizations/getById',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllAdjustTypes: config.endpoints.backend + 'adjusttypes/getall',
        endpointGetAllProjectUnits: config.endpoints.backend + 'projectunits/getall'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            !profileFilter.pdc_entity_id ? {
                name: 'pdc_entity_id',
                type: 'select',
                label: 'Entidade',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEntities,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4,
            } : {},
            {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4
            },
            {
                name: 'pdc_adjust_type_id',
                type: 'select',
                label: 'Tipo de Ajuste',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllAdjustTypes,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 4,
            },
            {
                name: 'period',
                name_start: 'date_start',
                name_end: 'date_end',
                type: 'date_period',
                label: 'Data',
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Contratualizações',
        labelTitleButtonAdd: 'Incluir nova contratualização',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        canDownload: true,
        fieldToDownload: 'file',
        formFilters: filters,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'entity',
                label: 'Entidade'
            },
            {
                name: 'project',
                label: 'Projeto'
            },
            {
                name: 'number',
                label: 'Número'
            },
            {
                name: 'adjust_type',
                label: 'Tipo de Ajuste'
            },
            {
                name: 'publish_date',
                label: 'Data de Publicação'
            },
            {
                name: 'created_at',
                label: 'Data de Criação'
            }
        ]
    };

    list = { ...list, ...paths };

    let form = {
        fields: [
            {
                name: 'pdc_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: pathsForm.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: true
                },
                columnSize: 12,
            },
            {
                name: 'pdc_adjust_type_id',
                type: 'select',
                label: 'Tipo de Ajuste',
                options: [],
                optionsEndpoint: {
                    endpoint: pathsForm.endpointGetAllAdjustTypes,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: true
                },
                columnSize: 12,
            },
            {
                name: 'number',
                type: 'text',
                label: 'Número',
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'object',
                type: 'textarea',
                label: 'Objeto',
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'publish_date',
                type: 'date',
                label: 'Data de Publicação',
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'file',
                type: 'fileS3',
                label: 'Arquivo',
                validations: {
                    required: true
                },
                columnSize: 12
            },
            {
                name: 'units',
                type: 'multiinput',
                label: 'Unidades',
                sortBy: 'index',
                form: [
                    {
                        label: 'Unidade',
                        type: 'select',
                        options: [],
                        optionsEndpoint: {
                            endpoint: pathsForm.endpointGetAllProjectUnits,
                            label: 'no_fantasia',
                            value: 'id'
                        },
                        name: 'unit',
                        validations: {
                            required: true
                        }
                    }
                ],
                validations: {
                    required: true
                },
                columnSize: 12
            },
        ],
        ...pathsForm,
        labelTitleModal: 'Visualizar Contratualização'
    }

    list.formToModal = form;

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
